import styled from 'styled-components';

export const ChatWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

export const BackTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1d3557;
  line-height: 9px;
`;

export const BackAction = styled.div`
  display: flex;
  align-items: center;
  width: 117px;
  border-radius: 10px;
  border: 0.4px solid #d4d8dd;
  background: #fff;
  cursor: pointer;
  height: 40px;
  margin: 20px;
`;

export const BackPermissions = styled.div`
  display: flex;
  align-items: center;
`;

export const BackMainMessage = styled.div``;

export const BackMessage = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #6c757d;
`;

export const BackMessage2 = styled.p`
  font-size: 18px;
  color: #212529;
  display: flex;
  font-weight: 500;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 0px;
  margin-left: 55px;
`;

export const Tab = styled.button`
  border: none;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? '#2D6CDF' : '#f8f9fa')};
  color: ${({ $active }) => ($active ? '#fff' : '#6c757d')};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $active }) => ($active ? '#2D6CDF' : '#e9ecef')};
  }
`;

export const TabButton1 = styled.button`
  border-radius: 8px;
  border: none;
  background: ${({ $isActive }) => ($isActive ? '#2D6CDF' : '#f8f9fa')};
  color: ${({ $isActive }) => ($isActive ? '#fff' : '#6c757d')};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
`;
